import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaUserGraduate, FaCheckCircle, FaFileAlt, FaShieldAlt } from 'react-icons/fa';
import '../../../../assets/css/general/footer/FeaturesDetail.css';

const DonorContribution = () => {
  return (
    <div className="feature-detail-page">
      <div className="feature-detail-container">
        {/* Back Button */}
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>

        {/* Header */}
        <div className="feature-header">
          <div className="feature-icon-large">
            <FaUserGraduate />
          </div>
          <h1 className="feature-title">Donor Contribution</h1>
          <p className="feature-subtitle">
            Make meaningful contributions and help students achieve their educational goals
          </p>
        </div>

        {/* Main Content */}
        <div className="feature-content">
          <section className="feature-section">
            <h2>Overview</h2>
            <p>
              The Donor Contribution feature empowers generous individuals to support
              deserving students with ease and confidence. Browse verified cases,
              contribute securely, and become part of a transparent support ecosystem
              that transforms students’ futures.
            </p>
          </section>

          <section className="feature-section">
            <h2>How It Works</h2>
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">1</div>
                <h3>Explore Requests</h3>
                <p>Browse verified student support requests that match your interest.</p>
              </div>
              <div className="step-card">
                <div className="step-number">2</div>
                <h3>Select a Case</h3>
                <p>Choose a student case you want to support and review the details.</p>
              </div>
              <div className="step-card">
                <div className="step-number">3</div>
                <h3>Contribute Securely</h3>
                <p>Make a safe and transparent donation directly to the institution.</p>
              </div>
              <div className="step-card">
                <div className="step-number">4</div>
                <h3>Make an Impact</h3>
                <p>See how your contribution helps students continue their education.</p>
              </div>
            </div>
          </section>

          <section className="feature-section">
            <h2>Key Features</h2>
            <div className="features-list">
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Verified Student Cases</h4>
                  <p>Support only authenticated and NGO-verified student requests</p>
                </div>
              </div>
              <div className="feature-item">
                <FaFileAlt className="feature-check" />
                <div>
                  <h4>Transparent Contributions</h4>
                  <p>Full visibility of where and how your donation is utilized</p>
                </div>
              </div>
              <div className="feature-item">
                <FaShieldAlt className="feature-check" />
                <div>
                  <h4>Secure Payment Process</h4>
                  <p>Your transactions are protected with strong security measures</p>
                </div>
              </div>
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Impact Assurance</h4>
                  <p>Ensure your support directly benefits deserving students</p>
                </div>
              </div>
            </div>
          </section>

          <section className="feature-section cta-section">
            <h2>Ready to Make a Difference?</h2>
            <p>Login to your donor account and start contributing to student success today.</p>
            <button className="cta-button">Start Contributing</button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DonorContribution;